import {smoothScrollTo} from "../../utils/Utils.js";

const Summary = (domEl, offset = 30) => {
	if (!domEl) {
		return;
	}

	const onNavigationLinkClicked = (e) => {
		e.preventDefault();

		// Extract the anchor part from the link href
		const url = new URL(e.currentTarget.href);
		const anchor = url.hash.substring(1); // Remove the leading '#'

		// Find the heading with the matching data-anchor attribute
		const targetHeading = document.querySelector(`[data-anchor="${anchor}"]`);

		if(targetHeading) {
			// Calculate the target position
			const targetPosition = targetHeading.getBoundingClientRect().top + window.scrollY - offset;

			// Perform custom smooth scroll
			smoothScrollTo(targetPosition, 500);

			// Shift focus to the target heading after a short delay
			setTimeout(() => {
				targetHeading.setAttribute('tabindex', '0'); // Make it focusable
				targetHeading.focus();
				targetHeading.removeAttribute('tabindex'); // Remove tabindex after focusing
			}, 501);
		}
	};

	domEl.querySelectorAll('.section-navigation-link a').forEach(link => link.addEventListener('click', onNavigationLinkClicked));
}

export default Summary;